import { useState } from "react";
import PetInformation from "../PetInformation";

const BPMesaurment = () => {
  const [results, setResults] = useState([
    { analyte: "Systolic Arterial Pressure Canine", result: "", range: "90-140", units: "mm Hg", comment: "False" },
    { analyte: "Systolic Arterial Pressure Feline", result: "", range: "80-140", units: "mm Hg", comment: "False" },
    { analyte: "Diastolic Arterial Pressure Canine", result: "", range: "50-80", units: "mm Hg", comment: "False" },
    { analyte: "Diastolic Arterial Pressure Feline", result: "", range: "55-75", units: "mm Hg", comment: "False" },
  ]);

  const handleChange = (index: number, field: string, value: string) => {
    const updatedResults = [...results];
    updatedResults[index][field] = value;
    setResults(updatedResults);
  };

  return (
    <div className="overflow-x-auto p-4">
      <PetInformation />

      {/* Blood Pressure Test Table */}
      <table className="min-w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200 print:bg-white">
            <th className="border border-gray-300 p-2 text-left  text-xs">Analytes</th>
            <th className="border border-gray-300 p-2 text-left text-xs">Result</th>
            <th className="border border-gray-300 p-2 text-left text-xs">Range</th>
            <th className="border border-gray-300 p-2 text-left text-xs">Units</th>
            <th className="border border-gray-300 p-2 text-left text-xs">Comment & Image</th>
          </tr>
        </thead>
        <tbody>
          {results.map((row, index) => (
            <tr key={index} className="text-xs">
              <td className="border border-gray-300 p-2 ">{row.analyte}</td>
              <td className="border border-gray-300 p-2 bg-gray-100 print:bg-white">
                <input
                  type="text"
                  value={row.result}
                  onChange={(e) => handleChange(index, "result", e.target.value)}
                  className="w-full bg-transparent outline-none text-xs"
                />
              </td>
              <td className="border border-gray-300 p-2">{row.range}</td>
              <td className="border border-gray-300 p-2">{row.units}</td>
              <td className="border border-gray-300 p-2">
                <input
                  type="text"
                  value={row.comment}
                  onChange={(e) => handleChange(index, "comment", e.target.value)}
                  className="w-full bg-transparent outline-none text-xs"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Doctor's Name */}
      <div className="flex items-center gap-2 mt-3">
        <p className="text-xs">Doctor's Name:</p>
        <input type="text" className="text-sm w-[400px] border p-1" />
      </div>

      <p className="mt-3 italic text-xs">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default BPMesaurment;
